<template>
  <div>
    <h1>Policy Specifications</h1>
    <policy-spec-form />
  </div>
</template>

<script>
import PolicySpecForm from './PolicySpecForm.vue'

export default {
  name: 'PolicySpecPolicyPart',
  components: {
    PolicySpecForm,
  },
  props: [],
  methods: {
  },
}
</script>

<style>
</style>
